import { Typography } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';

type Props = {
    title: string;
    detail: string;
    contentleft?: any;
    contentRight?: any;
}

const ContentHeading: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    return (
        <section className="w-full flex justify-between items-center gap-[4px]">
            <div>
                {props?.contentleft}
            </div>
            <div className='flex flex-col justify-center items-center'>
                <Typography variant='h3'>
                    {t(props.title)}
                </Typography>
                <Typography>
                    {t(props.detail)}
                </Typography>
            </div>
            <div>
                {props?.contentRight}
            </div>

        </section>
    )
}

export default ContentHeading